var exports = {
  "k": "xa9f3555f--c65734--container",
  "Q": "xa9f3555f--c65734--content",
};

module.exports = exports;
